import { jsxs, jsx } from "react/jsx-runtime";
import Space from "antd/es/space";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './DealerCard.css';import '../Grid/Grid.css';/* empty css                */
import Typography from "../Typography/Typography.js";
/* empty css                */
const DealerCardContact = ({
  phone,
  schedule,
  className
}) => {
  const isHiddenPhones = !phone.value.length;
  const isHiddenSchedules = !schedule.value.length;
  if (isHiddenPhones && isHiddenSchedules) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-blue"], className: classnames("perxis-auto-dealer-card-contact", className), children: [
    !isHiddenPhones && /* @__PURE__ */ jsx(Col, { xs: 24, sm: isHiddenSchedules ? 24 : 12, md: 24, lg: isHiddenSchedules ? 24 : 12, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
      /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(
        Typography.Text,
        {
          level: "small",
          color: "dark-light",
          className: classnames("perxis-auto-dealer-card-contact__phone-label"),
          children: [
            phone.label,
            ":"
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Space, { direction: "vertical", children: phone.value.map((value) => /* @__PURE__ */ jsx(
        Typography.Link,
        {
          level: "main",
          color: "darkest",
          href: `tel:${value}`,
          "data-phone": value,
          className: classnames("perxis-auto-dealer-card-contact__phone-value"),
          children: value
        },
        value
      )) }) })
    ] }) }),
    !isHiddenSchedules && /* @__PURE__ */ jsx(Col, { xs: 24, sm: isHiddenPhones ? 24 : 12, md: 24, lg: isHiddenPhones ? 24 : 12, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
      /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(
        Typography.Text,
        {
          level: "small",
          color: "dark-light",
          className: classnames("perxis-auto-dealer-card-contact__schedule-label"),
          children: [
            schedule.label,
            ":"
          ]
        }
      ) }),
      /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Space, { direction: "vertical", children: schedule.value.map((value) => /* @__PURE__ */ jsx(
        Typography.Paragraph,
        {
          level: "main",
          color: "darkest",
          className: classnames("perxis-auto-dealer-card-contact__schedule-value"),
          children: value
        },
        value
      )) }) })
    ] }) })
  ] });
};
export {
  DealerCardContact as default
};
//# sourceMappingURL=DealerCardContact.js.map
